// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nb-c";
export var backButton = "_nb-4";
export var backIcon = "_nb-5";
export var chevronShortcut = "_nb-6";
export var container = "_nb-1";
export var editor = "_nb-8";
export var editorWrapper = "_nb-7";
export var prefix = "_nb-2";
export var searchIcon = "_nb-3";
export var suffix = "_nb-9";
export var suffixContent = "_nb-a";
export var suffixText = "_nb-b";
export var wrapper = "_nb-0";